import { render, staticRenderFns } from "./quickorderCardProduct_child.vue?vue&type=template&id=8023686c&scoped=true"
import script from "./quickorderCardProduct_child.vue?vue&type=script&lang=js"
export * from "./quickorderCardProduct_child.vue?vue&type=script&lang=js"
import style0 from "./quickorderCardProduct_child.vue?vue&type=style&index=0&id=8023686c&prod&lang=scss&scoped=true"
import style1 from "./quickorderCardProduct_child.vue?vue&type=style&index=1&id=8023686c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8023686c",
  null
  
)

export default component.exports